export default {
  displayName: 'DiscountGallery',
  allowableParents: ['Section'],
};
